module.exports = MaterialUI.ClickAwayListener;